/* eslint-disable no-restricted-syntax */
const parseSchemaDocs = (schema, path = '', depth = 0, depthName = 'root') => {
  const docs = [];

  docs.push({
    path: path || 'root',
    title: schema.title,
    description: schema.description,
    comment: Array.isArray(schema.$comment)
      ? schema.$comment.join('\n')
      : schema.$comment,
    type: schema.type,
    depthName: depthName || 'root',
    depth,
  });

  if (schema.properties) {
    for (const [key, value] of Object.entries(schema.properties)) {
      docs.push(
        ...parseSchemaDocs(
          value,
          path ? `${path}.${key}` : key,
          depth + 1,
          path,
        ),
      );
    }
  }

  if (schema.$defs) {
    for (const [key, value] of Object.entries(schema.$defs)) {
      docs.push(...parseSchemaDocs(value, `${key}`, depth + 1, path));
    }
  }

  return docs.sort((a, b) => a.depth - b.depth);
};

export default parseSchemaDocs;
